export default __webpack_public_path__ + "static/media/visitors.3e9c32ce.jpg";